"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = showOffHelper;
exports.discoChangeBlockPattern = void 0;
require("core-js/modules/es.promise.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _RICRoboticalAddOns = require("@robotical/ricjs-robotical-addons/dist/RICRoboticalAddOns");
var _compareVersion = _interopRequireDefault(require("../compare-version"));
var _mv2Rn = _interopRequireDefault(require("../../rn-bridge/mv2-rn"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FILE_RUN_CHANGES_VERSION = '1.2.52';
function showOffHelper(moveSpeed) {
  const timesOfDancing = 2;
  discoChangeBlockPattern('on');
  if ((0, _compareVersion.default)(FILE_RUN_CHANGES_VERSION, _mv2Rn.default.getMartyVersion())) {
    _mv2Rn.default.send_REST("filerun/spiffs/sax-in-the-city.raw");
  } else {
    _mv2Rn.default.send_REST("filerun/celebrate.mp3");
  }
  _mv2Rn.default.send_REST("traj/dance?moveTime=".concat(moveSpeed));
  _mv2Rn.default.send_REST("traj/dance?moveTime=".concat(moveSpeed));
  return timesOfDancing;
}
const discoChangeBlockPattern = onOff => {
  const addons = _mv2Rn.default.getAddons();

  //so if it's set in a forever loop give 0.2s break between each update
  const resolveTime = 200;

  // select all LED addons found
  const addressList = getAllDiscoBoards(addons);
  let numberOfLEDAddons = addressList.length;
  for (var i = 0; i < numberOfLEDAddons; i++) {
    let ledDeviceName = addressList.pop();
    let ledCmd = "led/".concat(ledDeviceName, "/pattern/show-off");
    if (onOff === 'off') {
      ledCmd = "led/".concat(ledDeviceName, "/off");
    }
    _mv2Rn.default.send_REST(ledCmd);
  }
  return new Promise(resolve => setTimeout(resolve, resolveTime));
};
exports.discoChangeBlockPattern = discoChangeBlockPattern;
const getAllDiscoBoards = addons => {
  var addressList = [];
  for (let addon of addons) {
    if (addon.whoAmI === _RICRoboticalAddOns.RIC_WHOAMI_TYPE_CODE_ADDON_LEDEYE || addon.whoAmI === _RICRoboticalAddOns.RIC_WHOAMI_TYPE_CODE_ADDON_LEDARM || addon.whoAmI === _RICRoboticalAddOns.RIC_WHOAMI_TYPE_CODE_ADDON_LEDFOOT) {
      addressList.push(addon.name);
    }
  }
  return addressList;
};